export default "__VITE_ASSET__d139da23__"